/**
 * VoiceVisualizer - Audio level visualization bars.
 *
 * Shows animated bars that respond to voice activity.
 */

interface VoiceVisualizerProps {
  isActive: boolean
  role: 'user' | 'ai'
  barCount?: number
}

export function VoiceVisualizer({
  isActive,
  role,
  barCount = 5,
}: VoiceVisualizerProps) {
  const color = role === 'user' ? 'bg-accent' : 'bg-emerald-500'

  return (
    <div className="flex items-center justify-center gap-1 h-8">
      {Array.from({ length: barCount }).map((_, i) => (
        <div
          key={i}
          className={`w-1 rounded-full transition-all duration-150 ${color} ${
            isActive ? 'animate-pulse' : 'opacity-30'
          }`}
          style={{
            height: isActive ? `${20 + Math.random() * 12}px` : '8px',
            animationDelay: `${i * 100}ms`,
          }}
        />
      ))}
    </div>
  )
}

export default VoiceVisualizer
